<template>
  <el-form
    ref="form"
    :model="form"
    label-width="80px"
  >
    <el-input
      v-model="form.sendDatagram"
      type="textarea"
      :rows="25"
    />
  </el-form>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "DriverEdit",
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          bankOptions: []
        };
      }
    },
    mode: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: "",
      form: {},
      vehicleDatagram: {},
    };
  },
  methods: {
    getDatagram(code) {
      request({
        url: `/ntocc-basic-api/report/${code}`,
        method: "get"
      }).then(response => {
        this.form = response.data;
      });
    }
  }
};
</script>
<style scoped>
.custom-grid {
  display: inline-block;
  font-size: 14px;
  color: #8c939d;
  margin-right: 20px;
}

.avatar-uploader ::v-deep.el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  box-sizing: border-box;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
  border-width: 1px;
  border-style: dashed;
  border-color: #c0ccda;
}

.avatar-uploader-icon:hover {
  border-color: #409eff;
}

.avatar {
  width: 148px;
  height: 148px;
  display: block;
}





.el-date-editor {
  width: 100%;
}
</style>
